// src/lib/date.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Format a date as UTC (e.g., for display) so local timezones don't shift the calendar day
export function formatDateUTC(date, fmt = "MMM D, YYYY") {
  if (!date) return "—";
  const m = dayjs.utc(date);
  if (!m.isValid()) return "—";
  return m.format(fmt);
}

// For <input type="date"> values (YYYY-MM-DD) derived in UTC
export function formatInputDateUTC(date) {
  if (!date) return "";
  const m = dayjs.utc(date);
  if (!m.isValid()) return "";
  return m.format("YYYY-MM-DD");
}
